import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App.jsx";
import "@/index.css";
import { IS_GROOM, NAMES_TEXT } from "@/lib/side";

if (IS_GROOM) document.title = `Sona ka Raj · ${NAMES_TEXT} · Jaipur`;

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
